import React from "react"
import classnames from "@utils/classnames"
import styles from "./bottomContainer.module.scss"

const BottomContainer = React.memo(({ className, children }) => {
  return (
    <div className={classnames(className, styles.container)}>{children}</div>
  )
})

BottomContainer.displayName = "BottomContainer"
export default BottomContainer
